import { useCallback, useState } from 'react'

// Nøkkelversjonering: kan trigge ny modal dersom bruketype-kategori eller spørsmål endres.
// Bytt isåfall v1 --> v2 osv.
const STORAGE_KEY = 'trine.brukertypePrompt.v1'

const lesFraLocalStorage = () => {
    if (typeof window === 'undefined') {
        return false
    }

    try {
        return window.localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
        return false
    }
}

export default function useBrukertypeStatistikk() {
    const [harValgtBrukertype, setHarValgtBrukertype] = useState(lesFraLocalStorage)

    const oppdaterBrukertypeStatistikk = useCallback((harValgt = true) => {
        const nesteVerdi = Boolean(harValgt)
        setHarValgtBrukertype(nesteVerdi)

        if (typeof window !== 'undefined') {
            window.localStorage.setItem(STORAGE_KEY, String(nesteVerdi))
        }
    }, [])

    return [harValgtBrukertype, oppdaterBrukertypeStatistikk]
}
